import React from 'react'
import PropTypes from 'prop-types'

import qs from '@scoir/query-string'
import { get, findIndex, reduce, find, isEqual } from 'lodash'

import update from '@scoir/immutability'
import api from 'common/api'

import ExploreLayout from '../ExploreLayout'
import ExploreRail from '../ExploreRail'
import HighSchoolsTable from './HighSchoolsTable'

export default class ExploreList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      highSchools: [],
      totalHighSchools: 0,
      toggledHighSchools: [],
      loaded: false,
    }
  }
  static propTypes = {
    selectedHighSchoolId: PropTypes.string,
    dataFilters: PropTypes.object.isRequired,
    onHighSchoolSelect: PropTypes.func.isRequired,
  }
  componentDidUpdate(prevProps) {
    const isApiQueryChanging = !isEqual(prevProps.dataFilters, this.props.dataFilters)
    const hsIsChanging = !isEqual(prevProps.selectedHighSchoolId, this.props.selectedHighSchoolId)
    if (!hsIsChanging && isApiQueryChanging) {
      this.fetch(this.state)
    }
  }
  fetch({ pageSize, from, sortKey, sortDir }) {
    this.setState({
      pageSize,
      from,
      sortKey,
      sortDir,
    })
    const sort = sortDir === 'asc' ? sortKey : `-${sortKey}`
    const query = qs.stringify({
      ...this.props.dataFilters,
      limit: pageSize,
      map: false,
      from,
      sort,
    })
    api.get(`/api/highschools/locations?${query}`).then((result) => {
      const highSchoolExplores = get(result, 'HighSchoolExplores', [])
      const toggledHighSchools = reduce(
        this.state.toggledHighSchools,
        (arr, school) => {
          const found = find(highSchoolExplores, (explores) => explores.HighSchool.Id === school.Id)
          if (found) {
            found.selected = true
            arr.push({
              Id: found.HighSchool.Id,
              Name: found.HighSchool.SchoolName,
              NextVisitAvailability: found.HighSchool.NextVisitAvailability,
            })
          }
          return arr
        },
        [],
      )
      this.setState({
        highSchools: highSchoolExplores,
        toggledHighSchools,
        totalHighSchools: get(result, 'Total', 0),
        loaded: true,
      })
    })
  }
  toggleItem(idx) {
    const toggledHs = this.state.highSchools[idx]
    if (toggledHs.selected) {
      const foundIdx = findIndex(this.state.toggledHighSchools, (hs) => {
        return hs.Id === toggledHs.HighSchool.Id
      })
      const toggledHighSchools = update(this.state.toggledHighSchools, {
        $splice: [[foundIdx, 1]],
      })
      this.setState({ toggledHighSchools })
    } else {
      const toggledHighSchools = update(this.state.toggledHighSchools, {
        $push: [
          {
            Id: toggledHs.HighSchool.Id,
            Name: toggledHs.HighSchool.SchoolName,
            NextVisitAvailability: toggledHs.HighSchool.NextVisitAvailability,
          },
        ],
      })
      this.setState({ toggledHighSchools })
    }
    const highSchools = update(this.state.highSchools, {
      [idx]: {
        $toggle: ['selected'],
      },
    })
    this.setState({ highSchools })
  }
  render() {
    return (
      <div className="route-explore-list">
        <ExploreLayout
          rail={
            <ExploreRail
              selectedHighSchoolId={this.props.selectedHighSchoolId}
              defaultView={
                <ExploreRail.Empty>
                  Select a highschool
                  <br />
                  to see more details.
                </ExploreRail.Empty>
              }
            />
          }
          main={
            <HighSchoolsTable
              onTableChange={(context) => this.fetch(context)}
              highSchools={this.state.highSchools}
              totalHighSchools={this.state.totalHighSchools}
              onHighSchoolToggle={(idx) => this.toggleItem(idx)}
              toggledHighSchools={this.state.toggledHighSchools}
              onSelectHighSchool={(hs) => this.props.onHighSchoolSelect(hs.Id, hs.Latitude, hs.Longitude)}
              loaded={this.state.loaded}
            />
          }
        />
      </div>
    )
  }
}
